import type { IconProps } from './types';

export const Balloons = ({ size, ...props }: IconProps) => (
  <svg id="vector" xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 85 58" {...props}>
    <path
      fill="#51C7F4"
      d="M42.026,57.6561C28.366,57.6561 17.292,46.5311 17.292,32.8061C17.291,19.0791 28.365,7.9531 42.026,7.9531C55.688,7.9531 66.763,19.0791 66.763,32.8051C66.763,46.5301 55.688,57.6571 42.026,57.6571V57.6561Z"
      id="path_0"
    />
    <path
      fill="#ffffff"
      d="M29.3101,28.4742L37.4691,43.1512L38.2511,42.7132L30.0931,28.0352L29.3101,28.4742ZM55.2001,28.4742L47.0411,43.1512L46.2581,42.7132L54.4161,28.0352L55.2001,28.4742ZM41.6411,36.1641V42.2641H42.5371V36.1641H41.6411Z"
      id="path_1"
    />
    <path
      fill="#A23050"
      d="M46.5028,36.8159H37.5088C36.6788,36.8159 36.0068,36.1419 36.0068,35.3079V33.5529C36.0068,32.7199 36.6798,32.0449 37.5088,32.0449H46.5028C47.3318,32.0449 48.0038,32.7199 48.0038,33.5529V35.3079C48.0038,36.1419 47.3318,36.8159 46.5028,36.8159Z"
      id="path_2"
    />
    <path
      fill="#D4305E"
      d="M42.231,0.2632C51.699,0.2632 59.375,7.9752 59.375,17.4882C59.375,26.9982 51.699,34.7112 42.231,34.7112"
      id="path_3"
    />
    <path
      fill="#E6305E"
      d="M42.2309,0.2632C32.7619,0.2632 25.0859,7.9762 25.0859,17.4862C25.0859,26.9992 32.7619,34.7112 42.2309,34.7112"
      id="path_4"
    />
    <path
      fill="#FBBF24"
      d="M42.031,34.6552C36.467,30.9622 32.793,24.6272 32.793,17.4272C32.793,10.2262 36.467,3.8932 42.031,0.2002"
      id="path_5"
    />
    <path
      fill="#F98E23"
      d="M42.0312,34.6552C47.5953,30.9612 51.2693,24.6292 51.2693,17.4282C51.2693,10.2272 47.5953,3.8932 42.0312,0.1992"
      id="path_6"
    />
    <path fill="#FBBF24" d="M36,42H48V48C48,49.6569 46.6569,51 45,51H39C37.3431,51 36,49.6569 36,48V42Z" id="path_7" />
    <path
      fill="#F98E23"
      d="M41.6206,42C41.8035,42.3606 41.9322,42.7535 41.996,43.1679C42.0597,42.7535 42.1885,42.3606 42.3714,42H48V47.0007C47.3806,47.4211 46.6339,47.6667 45.8302,47.6667C43.8916,47.6667 42.2853,46.2379 41.9965,44.3722C41.7075,46.2379 40.1003,47.6667 38.1617,47.6667C37.3614,47.6667 36.6177,47.4231 36,47.0059V42H41.6206Z"
      id="path_8"
    />
    <path
      fill="#E6305E"
      d="M47.2172,44.3489H36.8442C36.1572,44.3489 35.5942,43.7839 35.5942,43.0939C35.5942,42.4039 36.1572,41.8369 36.8442,41.8369H47.2172C47.9042,41.8369 48.4672,42.4039 48.4672,43.0939C48.4672,43.7839 47.9042,44.3489 47.2172,44.3489Z"
      id="path_9"
    />
    <path
      fill="#B9F0FD"
      d="M50.4868,20.3884H50.4878L79.5178,20.5794C79.5178,20.5794 80.4948,17.6824 77.3358,15.3384C75.1538,13.7164 72.3078,14.7654 72.3078,14.7654C68.9878,6.0933 57.2238,6.3783 55.7068,16.5764C52.9548,15.6234 50.7728,17.2434 50.4868,20.3884ZM29.03,42.2081C29.03,42.2081 30.007,39.3111 26.848,36.9651C24.665,35.3451 21.82,36.3931 21.82,36.3931C18.5,27.7201 6.735,28.0061 5.217,38.2051C2.467,37.2511 0.284,38.8721 0,42.0171L29.03,42.2071V42.2081ZM81.2261,50.1892C80.1661,43.0682 71.9531,42.8692 69.6341,48.9252C69.6341,48.9252 67.6471,48.1922 66.1231,49.3252C63.9181,50.9612 64.6001,52.9832 64.6001,52.9832L84.8691,52.8502C84.6711,50.6542 83.1471,49.5242 81.2261,50.1892Z"
      id="path_10"
    />
  </svg>
);
